import * as React from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { Wrapper } from "../layout/Wrapper";
import {
  alpha,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Chip,
  Grid,
  Stack,
  useTheme,
} from "@mui/material";
import { Services } from "../components/Services";
import event from "../assets/event.png";
import car from "../assets/car.png";
import scheduler from "../assets/scheduler.png";

const Projects = ({ mode, toggleColorMode }) => {
  const theme = useTheme();

  const items = [
    {
      image: event,
      title: "Eveze",
      description:
        "Developed an innovative event management app tailored for organizers to streamline event planning and execution.",
      works: ["Web", "Mobile"],
    },
    {
      image: scheduler,
      title: "Scheduler",
      description:
        "Designed and Developed a scheduling app for a client to streamline their employee management.",
      works: ["Web", "Mobile"],
    },
    {
      image: car,
      title: "Car Rental CMS",
      description:
        "Developed a comprehensive content management system for efficient car rental management solutions.",
      works: ["Web"],
    },
  ];

  const [selectedItemIndex, setSelectedItemIndex] = React.useState(0);

  const handleItemClick = (index) => {
    setSelectedItemIndex(index);
  };

  return (
    <Wrapper mode={mode} toggleColorMode={toggleColorMode}>
      <Box
        sx={(theme) => ({
          width: "100%",
          background:
            theme.palette.mode === "light"
              ? // ? "linear-gradient(180deg, #CEE5FD, #FFF)"
                "#f6f4fa"
              : `linear-gradient(#02294F, ${alpha("#090E10", 0.0)})`,
          backgroundSize: "100% 20%",
          backgroundRepeat: "no-repeat",
        })}
      >
        <Container
          id="pricing"
          sx={{
            pt: { xs: 14 },
            pb: { xs: 8 },
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 3, sm: 6 },
          }}
        >
          <Box
            sx={{
              width: { sm: "100%", md: "100%" },
              textAlign: { sm: "center", md: "center" },
            }}
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                color:
                  theme.palette.mode === "light"
                    ? theme.palette.secondary.main
                    : "#9043c6",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              SEE OUR PROJECTS
            </Typography>
            <Typography
              component="h2"
              variant="h4"
              color="text.primary"
              fontWeight="bold"
              textAlign="center"
              sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
            >
              Our achievements are a testament to our commitment.
            </Typography>
            <Typography
              variant="body1"
              color="text.secondary"
              textAlign="center"
            >
              Continuously delivering outstanding outcomes that fuel progress,
              transform industries, and enhance lives.
            </Typography>

            <Grid
              container
              spacing={4}
              sx={{ mt: 8, mb: 4 }}
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              {items.map(
                ({ image, darkImage, title, description, works }, index) => (
                  <Grid
                    item
                    key={index}
                    sx={{ display: "flex" }}
                    xs={12}
                    md={4}
                  >
                    <Stack
                      direction="row"
                      justifyContent="center"
                      alignItems="flex-start"
                      spacing={2}
                      useFlexGap
                      sx={{
                        width: "100%",
                        display: "flex",
                      }}
                    >
                      <Card
                        key={index}
                        onClick={() => handleItemClick(index)}
                        sx={{
                          maxWidth: 345,
                          cursor: "pointer",
                          background: "none",
                          backgroundColor:
                            selectedItemIndex === index
                              ? "action.selected"
                              : undefined,
                          borderColor: (theme) => {
                            if (theme.palette.mode === "light") {
                              return selectedItemIndex === index
                                ? "primary.light"
                                : "grey.200";
                            }
                            return selectedItemIndex === index
                              ? "primary.dark"
                              : "grey.800";
                          },
                          transition: "transform 0.3s ease", // Smooth transition for scaling
                          "&:hover": {
                            transform: "scale(1.05)", // Zoom in on hover
                          },
                        }}
                      >
                        <CardMedia
                          sx={{
                            height: 150,
                          }}
                          image={image}
                          // image={
                          //   theme.palette.mode === "dark" ? darkImage : image
                          // }
                          title="image"
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h5" component="div">
                            {title}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ color: "text.secondary" }}
                          >
                            {description}
                          </Typography>
                        </CardContent>
                        <CardActions sx={{ p: 2 }}>
                          {works.map((work, i) => (
                            <Chip label={work} color="info" />
                          ))}
                        </CardActions>
                      </Card>
                    </Stack>
                  </Grid>
                )
              )}
            </Grid>
          </Box>
          <Services />
        </Container>
      </Box>
    </Wrapper>
  );
};

export default Projects;
